import { useTranslation } from "react-i18next";

import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import GaiaDataGrid from "~/modules/app/components/GaiaTable";

import { ObservationTypeFunctionTypeDataGridFragment } from "./fragments.generated";

type Props = {
    observationTypeFunctionTypes: ObservationTypeFunctionTypeDataGridFragment[];
    isAdmin: boolean;
    onDeleteClick: (ecologicalFunctionTypeId: string) => Promise<void>;
    isLoading: boolean;
};

export default function ObservationTypeFunctionTypeDataGrid({
    observationTypeFunctionTypes,
    isAdmin,
    isLoading,
    onDeleteClick,
}: Props) {
    const { t } = useTranslation("observationType");

    return (
        <GaiaDataGrid
            rows={observationTypeFunctionTypes}
            columns={[
                {
                    field: "name",
                    headerName: t("observationTypeFunctionTypeDataGrid.headerName"),
                    flex: 1,
                },
                ...(isAdmin
                    ? [
                          {
                              type: "actions" as const,
                              field: "actions",
                              headerName: t("observationTypeFunctionTypeDataGrid.headerDelete"),
                              flex: 1,
                              renderCell: (params: { row: { id: string } }) => (
                                  <GaiaDeleteButton
                                      isLoading={isLoading}
                                      onDelete={() => onDeleteClick(params.row.id)}
                                  />
                              ),
                          },
                      ]
                    : []),
            ]}
            loading={isLoading}
            rowCount={observationTypeFunctionTypes.length}
        />
    );
}
